module.exports = __webpack_public_path__ + "img/user.849bc05f.svg";